import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FileText, Star } from "lucide-react";
import { Card, CardContent } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";

const PostulacionesMobile = ({
  sortedPostulaciones = [],
  tenderInfo,
  downloadFile,
  confirmSelectWinner,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4 pt-4">
      {Array.isArray(sortedPostulaciones) && sortedPostulaciones.length > 0 ? (
        sortedPostulaciones.map((postulacion) => (
          <Card key={postulacion.id_application}>
            <CardContent className="space-y-2 pt-6 text-sm">
              <p>
                <strong className="text-foreground">Postulación ID:</strong> {postulacion.id_application}
              </p>
              {postulacion.company_postulante && (
                <p>
                  <strong className="text-foreground">Empresa:</strong>{" "}
                  <Link
                    to={`/company-profile/${postulacion.company_postulante.id_company}/${encodeURIComponent(
                      postulacion.company_postulante.nombre_empresa
                    )}`}
                    className="font-semibold text-primary hover:underline"
                  >
                    {postulacion.company_postulante.nombre_empresa.length > 25
                      ? `${postulacion.company_postulante.nombre_empresa.slice(0, 25)}...`
                      : postulacion.company_postulante.nombre_empresa}
                  </Link>
                </p>
              )}
              <p>
                <strong className="text-foreground">Postulante:</strong>{" "}
                <Link
                  to={`/profile/${postulacion.user_postulante.id_user}/${encodeURIComponent(
                    `${postulacion.user_postulante.nombre} ${postulacion.user_postulante.apellido}`
                  )}`}
                  className="font-semibold text-primary hover:underline"
                >
                  {`${postulacion.user_postulante.nombre} ${postulacion.user_postulante.apellido}`.length > 25
                    ? `${`${postulacion.user_postulante.nombre} ${postulacion.user_postulante.apellido}`.slice(0, 25)}...`
                    : `${postulacion.user_postulante.nombre} ${postulacion.user_postulante.apellido}`}
                </Link>
              </p>
              <p>
                <strong className="text-foreground">Cel:</strong>{" "}
                {`+${postulacion.user_postulante.codigo_pais} ${postulacion.user_postulante.celular}`.length > 25
                  ? `${`+${postulacion.user_postulante.codigo_pais} ${postulacion.user_postulante.celular}`.slice(0, 25)}...`
                  : `+${postulacion.user_postulante.codigo_pais} ${postulacion.user_postulante.celular}`}
              </p>
              <p>
                <strong className="text-foreground">Correo:</strong>{" "}
                {postulacion.user_postulante.correo.length > 35
                  ? `${postulacion.user_postulante.correo.slice(0, 35)}...`
                  : postulacion.user_postulante.correo}
              </p>
              <p>
                <strong className="text-foreground">Propuesta:</strong>{" "}
                {postulacion.detalles_oferta.length > 150
                  ? `${postulacion.detalles_oferta.slice(0, 150)}...`
                  : postulacion.detalles_oferta}
              </p>

              {postulacion.archivos_adjuntos && postulacion.archivos_adjuntos.length > 0 && (
                <div>
                  <p>
                    <strong className="text-foreground">📂 Documentos Adjuntos:</strong>
                  </p>
                  <ul className="mt-1 space-y-1">
                    {postulacion.archivos_adjuntos.map((archivo, archivoIndex) => (
                      <li key={archivoIndex}>
                        <button
                          onClick={() => downloadFile(archivo.id_file)}
                          className="flex items-center gap-1.5 text-primary hover:underline"
                        >
                          <FileText className="h-4 w-4" />
                          {archivo.file_name.length > 30 ? `${archivo.file_name.slice(0, 30)}...` : archivo.file_name}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {Object.entries(postulacion.respuestas_preguntas_licitador).map(([pregunta, respuesta], index) => {
                if (typeof respuesta === "object" && respuesta?.file_name) {
                  return (
                    <div key={index}>
                      <p>
                        <strong className="text-foreground">{pregunta} (Adjunto):</strong>
                      </p>
                      <button
                        onClick={() => downloadFile(respuesta.id_file)}
                        className="flex items-center gap-1.5 text-primary hover:underline"
                      >
                        <FileText className="h-4 w-4" />
                        {respuesta.file_name.length > 30
                          ? `${respuesta.file_name.slice(0, 30)}...`
                          : respuesta.file_name}
                      </button>
                    </div>
                  );
                }
                return null;
              })}

              <div className="flex justify-center gap-2 pt-2">
                <Button
                  size="sm"
                  onClick={() =>
                    navigate(`/tender/${postulacion.id_tender}/application/${postulacion.id_application}`)
                  }
                >
                  Ver Postulación Completa
                </Button>
                {tenderInfo?.tender?.ganador === postulacion.id_application ? (
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => navigate(`/admin-contrato/${tenderInfo.tender.id_tender}`)}
                  >
                    <Star className="h-3.5 w-3.5" /> Ganador
                  </Button>
                ) : (
                  confirmSelectWinner &&
                  tenderInfo?.tender?.estado !== "licitacion-ganada" && (
                    <Button size="sm" variant="outline" onClick={() => confirmSelectWinner(postulacion)}>
                      Escoger como ganador
                    </Button>
                  )
                )}
              </div>
            </CardContent>
          </Card>
        ))
      ) : (
        <p className="text-sm text-muted-foreground">No hay postulaciones disponibles.</p>
      )}
    </div>
  );
};

export default PostulacionesMobile;
